// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-planner, .schedule-dialog {
  color: #242136;
}
.schedule-planner button, .schedule-planner input, .schedule-planner select, .schedule-dialog button, .schedule-dialog input, .schedule-dialog select {
  font: inherit;
}
.schedule-planner button, .schedule-dialog button {
  cursor: pointer;
  min-height: 42px;
  border: 1px solid #dfe4ef;
  border-radius: 11px;
  background: #fff;
  color: inherit;
  padding: 9px 12px;
  font-size: 13px;
  font-weight: 600;
}
.schedule-planner button:disabled, .schedule-dialog button:disabled {
  cursor: default;
  opacity: 0.45;
}
.schedule-planner button:focus-visible, .schedule-planner input:focus-visible, .schedule-planner select:focus-visible, .schedule-dialog button:focus-visible, .schedule-dialog input:focus-visible, .schedule-dialog select:focus-visible {
  outline: 2px solid #ed294a;
  outline-offset: 2px;
}
.schedule-planner .schedule-primary, .schedule-dialog .schedule-primary {
  background: #ef2848;
  color: #fff;
  border-color: #ef2848;
}
.schedule-planner input:not([type=checkbox]), .schedule-planner select, .schedule-dialog input:not([type=checkbox]), .schedule-dialog select {
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  min-height: 42px;
  border: 1px solid #dfe4ef;
  border-radius: 11px;
  background: #fff;
  padding: 9px 10px;
  color: inherit;
  font-size: 16px;
}
.schedule-planner label, .schedule-dialog label {
  display: grid;
  gap: 6px;
  font-size: 12px;
  color: #738099;
}
.schedule-planner small, .schedule-dialog small {
  display: block;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.4;
  color: #738099;
}
.schedule-planner h2, .schedule-planner h3, .schedule-planner p, .schedule-dialog h2, .schedule-dialog h3, .schedule-dialog p {
  margin: 0;
}
.schedule-planner h2, .schedule-dialog h2 {
  font-size: 17px;
}
.schedule-planner h3, .schedule-dialog h3 {
  font-size: 15px;
}
.schedule-planner .schedule-icon, .schedule-dialog .schedule-icon {
  flex: none;
  width: 42px;
  padding: 0;
  font-size: 23px;
}
.schedule-planner .schedule-text-button, .schedule-dialog .schedule-text-button {
  border: 0;
  padding: 4px 0;
  min-height: 36px;
  color: #ca2642;
  background: transparent;
}

.schedule-controls {
  display: grid;
  grid-template-columns: minmax(200px, 1fr) minmax(220px, 2fr);
  gap: 12px;
  margin-bottom: 12px;
}

.schedule-month-control {
  display: flex;
  gap: 5px;
  min-width: 0;
}

.schedule-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.schedule-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  margin: 10px 0 14px;
  font-size: 11px;
  color: #738099;
}

.schedule-legend span {
  display: flex;
  align-items: center;
  gap: 5px;
}

.schedule-legend i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex: none;
}

.schedule-workspace {
  display: grid;
  grid-template-columns: minmax(280px, 360px) minmax(0, 1fr);
  align-items: start;
  gap: 14px;
}

.schedule-month-card, .schedule-day-card {
  background: #fff;
  border: 1px solid #e1e6f0;
  border-radius: 18px;
  padding: 14px;
  min-width: 0;
}

.schedule-section-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.schedule-section-heading h2 {
  text-transform: capitalize;
}

.schedule-section-heading > span {
  color: #738099;
  font-size: 11px;
  white-space: nowrap;
}

.schedule-calendar {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 4px;
}

.schedule-calendar .schedule-weekday {
  text-align: center;
  color: #8b95aa;
  font-size: 11px;
  padding: 4px 0;
}

.schedule-calendar button {
  border: 1px solid transparent;
  padding: 4px 0;
  min-height: 42px;
  font-size: 14px;
  background: #f7f8fc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
}

.schedule-calendar button.is-selected {
  background: #fff0f3;
  border-color: #ee2d4a;
  color: #d31e3d;
}

.schedule-calendar button.is-today > span {
  font-weight: 800;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.schedule-dots {
  display: flex;
  justify-content: center;
  gap: 2px;
  min-height: 4px;
}

.schedule-dots b {
  width: 4px;
  height: 4px;
  border-radius: 50%;
}

.schedule-hint {
  font-size: 12px;
  color: #7c89a2;
  line-height: 1.5;
}

.schedule-month-card > .schedule-hint {
  margin-top: 10px;
}

.schedule-search {
  margin-bottom: 10px;
}

.schedule-masters {
  display: grid;
  gap: 8px;
}

.schedule-master {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid #e7eaf2;
  border-left: 3px solid;
  border-radius: 11px;
  padding: 10px;
}

.schedule-master > div {
  min-width: 0;
}

.schedule-master strong {
  display: block;
  font-size: 14px;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.schedule-master small {
  margin-top: 3px;
}

.schedule-master button {
  font-size: 11px;
  padding: 7px 9px;
}

.schedule-time, .schedule-off {
  display: block;
  margin-top: 6px;
  font-size: 13px;
  font-weight: 600;
}

.schedule-off {
  color: #9ca4b5;
  font-weight: 400;
}

.schedule-master.has-draft {
  background: #fffcf3;
}

.schedule-draft-label {
  color: #9e7324 !important;
}

.schedule-draft-bar {
  position: sticky;
  bottom: calc(70px + env(safe-area-inset-bottom));
  z-index: 9;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  background: #fff;
  border: 1px solid #e4e7ef;
  border-radius: 14px;
  padding: 12px;
  margin-top: 14px;
  box-shadow: 0 5px 22px rgba(37, 34, 56, 0.0823529412);
}

.schedule-draft-bar > div {
  flex: 1 1;
  min-width: 120px;
}

.schedule-draft-bar strong {
  font-size: 14px;
}

.schedule-error, .schedule-notice {
  border-radius: 11px;
  padding: 10px 12px;
  margin: 10px 0 !important;
  font-size: 13px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.schedule-error {
  color: #c22441;
  background: #fff1f4;
}

.schedule-error button {
  margin-left: 8px;
}

.schedule-notice {
  background: #edf7f2;
  color: #227855;
}

.schedule-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(36, 33, 54, 0.3333333333);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  box-sizing: border-box;
}

.schedule-dialog {
  width: 100%;
  max-width: 620px;
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 18px;
  background: #fff;
  border-radius: 20px;
  box-sizing: border-box;
  display: grid;
  gap: 14px;
  box-shadow: 0 10px 60px rgba(36, 33, 54, 0.1882352941);
}

.schedule-dialog header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.schedule-dialog fieldset {
  margin: 0;
  padding: 10px 0 0;
  border: 0;
  border-top: 1px solid #edf0f5;
  min-width: 0;
}

.schedule-dialog legend {
  font-size: 13px;
  font-weight: 600;
}

.schedule-staff-options {
  display: grid;
  gap: 6px;
  max-height: 190px;
  overflow-y: auto;
  margin-bottom: 6px;
}

.schedule-staff-options label, .schedule-online {
  display: flex !important;
  align-items: center;
  gap: 8px;
  color: #242136;
  font-size: 13px;
  min-height: 40px;
}

.schedule-staff-options input, .schedule-online input {
  width: 18px;
  height: 18px;
  flex: none;
  accent-color: #ef2848;
}

.schedule-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin: 10px 0;
}

.schedule-presets button {
  font-size: 11px;
  min-height: 36px;
  padding: 6px 9px;
  background: #f5f6fa;
}

.schedule-presets button.is-selected {
  background: #fff0f3;
  border-color: #ef2848;
  color: #c22441;
}

.schedule-period {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 42px;
  gap: 8px;
  align-items: end;
  background: #f7f8fb;
  padding: 10px;
  border-radius: 12px;
  margin: 6px 0;
}

.schedule-period .schedule-online {
  grid-column: 1/-1;
  min-height: 30px;
}

.schedule-preview {
  display: grid;
  gap: 12px;
}

.schedule-preview section {
  border-left: 3px solid;
  padding-left: 10px;
}

.schedule-preview section > p {
  font-size: 12px;
  color: #738099;
  margin: 4px 0 8px;
}

.schedule-preview-day {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  padding: 8px 0;
  border-top: 1px solid #edf0f5;
}

.schedule-preview-day > strong {
  font-weight: 500;
}

.schedule-preview-day > span {
  text-align: right;
}

.schedule-transfer {
  border: 1px solid #e7eaf1;
  background: #f8f9fc;
  padding: 12px;
  border-radius: 12px;
}

.schedule-transfer p {
  font-size: 12px;
  margin: 8px 0;
}

@media (max-width: 760px) {
  .schedule-controls {
    grid-template-columns: minmax(0, 1fr);
    gap: 8px;
  }
  .schedule-workspace {
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
  }
  .schedule-month-card, .schedule-day-card {
    padding: 12px;
  }
  .schedule-month-card .schedule-calendar button {
    min-height: 40px;
  }
  .schedule-overlay {
    align-items: flex-end;
    padding: 0;
  }
  .schedule-dialog {
    border-radius: 20px 20px 0 0;
    padding: 14px 12px calc(18px + env(safe-area-inset-bottom));
    max-height: 92dvh;
  }
  .schedule-dialog header h2 {
    font-size: 17px;
  }
  .schedule-draft-bar {
    padding: 10px;
  }
  .schedule-draft-bar > .schedule-primary {
    width: 100%;
  }
}
.schedule-view-tabs {
  display: flex;
  gap: 4px;
  width: fit-content;
  max-width: 100%;
  padding: 4px;
  border: 1px solid #e1e6f0;
  border-radius: 12px;
  background: #edf0f6;
  margin: 10px 0;
}

.schedule-view-tabs button {
  background: transparent;
  border-color: transparent;
  min-height: 36px;
  padding: 7px 14px;
}

.schedule-view-tabs button[aria-selected=true] {
  background: #fff;
  border-color: #e1e6f0;
  color: #d52241;
  box-shadow: 0 2px 5px rgba(36, 33, 54, 0.031372549);
}

.schedule-matrix-card {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e1e6f0;
  border-radius: 16px;
  background: #fff;
}

.schedule-matrix-card > .schedule-section-heading {
  padding: 14px 14px 0;
  margin-bottom: 8px;
}

.schedule-matrix-tools {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 14px 12px;
}

.schedule-matrix-tools button {
  flex: none;
  min-height: 36px;
  font-size: 12px;
}

.schedule-matrix-scroll {
  --matrix-name-width: 164px;
  overflow: auto;
  max-height: 65dvh;
  max-width: 100%;
  scrollbar-width: thin;
  scrollbar-color: #bcc4d5 #f0f2f7;
  border-top: 1px solid #e1e6f0;
}

.schedule-matrix-scroll:focus-visible {
  outline: 2px solid #ed294a;
  outline-offset: -2px;
}

.schedule-matrix {
  border-collapse: separate;
  border-spacing: 0;
  width: max-content;
  table-layout: fixed;
  font-size: 12px;
}

.schedule-matrix th, .schedule-matrix td {
  min-width: 88px;
  width: 88px;
  max-width: 88px;
  box-sizing: border-box;
  padding: 3px;
  border-right: 1px solid #e3e7f0;
  border-bottom: 1px solid #e3e7f0;
  background: #fff;
  text-align: center;
  vertical-align: middle;
}

.schedule-matrix th:first-child {
  min-width: var(--matrix-name-width);
  width: var(--matrix-name-width);
  max-width: var(--matrix-name-width);
  position: sticky;
  left: 0;
  z-index: 2;
  text-align: left;
  padding: 10px 12px;
  box-shadow: 2px 0 3px rgba(36, 33, 54, 0.031372549);
}

.schedule-matrix th strong {
  display: block;
  font-size: 12px;
  font-weight: 600;
}

.schedule-matrix tbody th strong {
  font-size: 13px;
  overflow-wrap: anywhere;
}

.schedule-matrix th small {
  display: block;
  font-size: 10px;
  margin-top: 4px;
}

.schedule-matrix thead th {
  position: sticky;
  top: 0;
  z-index: 3;
  height: 52px;
  background: #f7f8fc;
}

.schedule-matrix thead th:first-child {
  z-index: 4;
}

.schedule-matrix thead th.is-weekend {
  background: #fff5f6;
  color: #d52241;
}

.schedule-matrix thead th.is-today {
  box-shadow: inset 0 -2px #ed294a;
}

.schedule-matrix td.is-selected-day, .schedule-matrix th.is-selected-day {
  background: #f6f7fc;
}

.schedule-matrix td.has-draft {
  box-shadow: inset 0 0 0 1px #d5a43c;
}

.schedule-matrix .schedule-matrix-shift {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
  width: 100%;
  padding: 6px 4px;
  min-height: 46px;
  margin: 2px 0;
  background: var(--salon-tint);
  border: 0;
  border-left: 3px solid var(--salon-color);
  border-radius: 4px;
  font-weight: 500;
  font-size: 11px;
  scroll-margin-inline-start: var(--matrix-name-width);
}

.schedule-matrix .schedule-matrix-shift:disabled {
  opacity: 1;
  cursor: default;
}

.schedule-matrix-shift.is-off {
  border-left-style: dashed;
}

.schedule-matrix-address {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 10px;
  color: #556078;
}

.schedule-matrix-times {
  display: block;
  font-size: 10px;
  font-variant-numeric: tabular-nums;
}

.schedule-matrix-pending {
  display: block;
  color: #91691c;
  font-size: 9px;
}

.schedule-matrix .schedule-matrix-empty {
  width: 100%;
  min-height: 50px;
  color: #b3bbcc;
  border: 0;
  border-radius: 4px;
  background: transparent;
  font-size: 17px;
  font-weight: 400;
  scroll-margin-inline-start: var(--matrix-name-width);
}

.schedule-matrix .schedule-matrix-empty:hover {
  background: #fff0f3;
  color: #d52241;
}

.schedule-matrix-empty-static {
  display: block;
  padding: 17px 0;
  color: #b3bbcc;
}

.schedule-matrix-scroll-hint {
  padding: 10px 14px;
}

@media (max-width: 760px) {
  .schedule-view-tabs {
    width: 100%;
    box-sizing: border-box;
  }
  .schedule-view-tabs button {
    flex: 1 1;
    padding-inline: 8px;
  }
  .schedule-matrix-scroll {
    --matrix-name-width: 120px;
  }
  .schedule-matrix th:first-child {
    padding: 8px;
  }
  .schedule-matrix-tools {
    align-items: flex-start;
    padding-inline: 12px;
  }
  .schedule-matrix-tools > p {
    font-size: 11px;
  }
  .schedule-matrix-tools button {
    padding: 6px 8px;
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/SchedulePage/schedule.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AAAE;EAAwB,aAAA;AAG1B;AAFE;EAAS,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,mBAAA;EAAqB,gBAAA;EAAkB,cAAA;EAAgB,iBAAA;EAAmB,eAAA;EAAiB,gBAAA;AAapK;AAZE;EAAkB,eAAA;EAAiB,aAAA;AAgBrC;AAfE;EAAkE,0BAAA;EAA4B,mBAAA;AAmBhG;AAlBE;EAAoB,mBAAA;EAAqB,WAAA;EAAa,qBAAA;AAuBxD;AAtBE;EAAqC,WAAA;EAAa,sBAAA;EAAwB,YAAA;EAAc,gBAAA;EAAkB,yBAAA;EAA2B,mBAAA;EAAqB,gBAAA;EAAkB,iBAAA;EAAmB,cAAA;EAAgB,eAAA;AAkCjN;AAjCE;EAAQ,aAAA;EAAe,QAAA;EAAU,eAAA;EAAiB,cAAA;AAuCpD;AAtCE;EAAQ,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;EAAkB,cAAA;AA6C/E;AA5CE;EAAY,SAAA;AA+Cd;AA9CE;EAAK,eAAA;AAiDP;AAhDE;EAAK,eAAA;AAmDP;AAlDE;EAAiB,UAAA;EAAY,WAAA;EAAa,UAAA;EAAY,eAAA;AAwDxD;AAvDE;EAAwB,SAAA;EAAW,cAAA;EAAgB,gBAAA;EAAkB,cAAA;EAAgB,uBAAA;AA8DvF;;AA5DA;EAAqB,aAAA;EAAe,4DAAA;EAA8D,SAAA;EAAW,mBAAA;AAmE7G;;AAlEA;EAA0B,aAAA;EAAe,QAAA;EAAU,YAAA;AAwEnD;;AAvEA;EAAoB,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,mBAAA;AA8E9D;;AA7EA;EAAmB,aAAA;EAAe,eAAA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,eAAA;EAAiB,cAAA;AAsFxG;;AArFA;EAAwB,aAAA;EAAe,mBAAA;EAAqB,QAAA;AA2F5D;;AA1FA;EAAqB,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,UAAA;AAiGlE;;AAhGA;EAAsB,aAAA;EAAe,0DAAA;EAA4D,kBAAA;EAAoB,SAAA;AAuGrH;;AAtGA;EAA2C,gBAAA;EAAkB,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,YAAA;AA8G5H;;AA7GA;EAA4B,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,QAAA;EAAU,mBAAA;AAqH1G;;AApHA;EAA+B,0BAAA;AAwH/B;;AAvHA;EAAmC,cAAA;EAAgB,eAAA;EAAiB,mBAAA;AA6HpE;;AA5HA;EAAqB,aAAA;EAAe,gDAAA;EAAkD,QAAA;AAkItF;;AAjIA;EAAuC,kBAAA;EAAoB,cAAA;EAAgB,eAAA;EAAiB,cAAA;AAwI5F;;AAvIA;EAA4B,6BAAA;EAA+B,cAAA;EAAgB,gBAAA;EAAkB,eAAA;EAAiB,mBAAA;EAAqB,aAAA;EAAe,sBAAA;EAAwB,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;AAoJxN;;AAnJA;EAAwC,mBAAA;EAAqB,qBAAA;EAAuB,cAAA;AAyJpF;;AAxJA;EAA4C,gBAAA;EAAkB,0BAAA;EAA4B,0BAAA;AA8J1F;;AA7JA;EAAiB,aAAA;EAAe,uBAAA;EAAyB,QAAA;EAAU,eAAA;AAoKnE;;AAnKA;EAAmB,UAAA;EAAY,WAAA;EAAa,kBAAA;AAyK5C;;AAxKA;EAAiB,eAAA;EAAiB,cAAA;EAAgB,gBAAA;AA8KlD;;AA7KA;EAAwC,gBAAA;AAiLxC;;AAhLA;EAAmB,mBAAA;AAoLnB;;AAnLA;EAAoB,aAAA;EAAe,QAAA;AAwLnC;;AAvLA;EAAmB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,QAAA;EAAU,yBAAA;EAA2B,sBAAA;EAAwB,mBAAA;EAAqB,aAAA;AAkMzK;;AAjMA;EAAyB,YAAA;AAqMzB;;AApMA;EAA0B,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;AA2M7E;;AA1MA;EAAyB,eAAA;AA8MzB;;AA7MA;EAA0B,eAAA;EAAiB,gBAAA;AAkN3C;;AAjNA;EAAgC,cAAA;EAAgB,eAAA;EAAiB,eAAA;EAAiB,gBAAA;AAwNlF;;AAvNA;EAAgB,cAAA;EAAgB,gBAAA;AA4NhC;;AA3NA;EAA6B,mBAAA;AA+N7B;;AA9NA;EAAwB,yBAAA;AAkOxB;;AAjOA;EAAsB,gBAAA;EAAkB,gDAAA;EAAkD,UAAA;EAAY,aAAA;EAAe,mBAAA;EAAqB,eAAA;EAAiB,QAAA;EAAU,gBAAA;EAAkB,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,gBAAA;EAAkB,qDAAA;AAiPxQ;;AAhPA;EAA4B,SAAA;EAAS,gBAAA;AAqPrC;;AApPA;EAA6B,eAAA;AAwP7B;;AAvPA;EAAoC,mBAAA;EAAqB,kBAAA;EAAoB,yBAAA;EAA2B,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;AAgQ3I;;AA/PA;EAAkB,cAAA;EAAgB,mBAAA;AAoQlC;;AAnQA;EAAyB,gBAAA;AAuQzB;;AAtQA;EAAmB,mBAAA;EAAqB,cAAA;AA2QxC;;AA1QA;EAAoB,eAAA;EAAiB,QAAA;EAAU,aAAA;EAAe,0CAAA;EAAuB,aAAA;EAAe,uBAAA;EAAyB,mBAAA;EAAqB,aAAA;EAAe,sBAAA;AAsRjK;;AArRA;EAAmB,WAAA;EAAa,gBAAA;EAAkB,+BAAA;EAAiC,gBAAA;EAAkB,4BAAA;EAA8B,aAAA;EAAe,gBAAA;EAAkB,mBAAA;EAAqB,sBAAA;EAAwB,aAAA;EAAe,SAAA;EAAW,sDAAA;AAoS3O;;AAnSA;EAA0B,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,QAAA;AA0S9F;;AAzSA;EAA4B,SAAA;EAAW,iBAAA;EAAmB,SAAA;EAAW,6BAAA;EAA+B,YAAA;AAiTpG;;AAhTA;EAA0B,eAAA;EAAiB,gBAAA;AAqT3C;;AApTA;EAA0B,aAAA;EAAe,QAAA;EAAU,iBAAA;EAAmB,gBAAA;EAAkB,kBAAA;AA4TxF;;AA3TA;EAAkD,wBAAA;EAA0B,mBAAA;EAAqB,QAAA;EAAU,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAoU5I;;AAnUA;EAAwD,WAAA;EAAa,YAAA;EAAc,UAAA;EAAY,qBAAA;AA0U/F;;AAzUA;EAAoB,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,cAAA;AAgV9D;;AA/UA;EAA2B,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;EAAkB,mBAAA;AAsVhF;;AArVA;EAAuC,mBAAA;EAAqB,qBAAA;EAAuB,cAAA;AA2VnF;;AA1VA;EAAmB,aAAA;EAAe,yDAAA;EAA2D,QAAA;EAAU,gBAAA;EAAkB,mBAAA;EAAqB,aAAA;EAAe,mBAAA;EAAqB,aAAA;AAqWlL;;AApWA;EAAoC,iBAAA;EAAqB,gBAAA;AAyWzD;;AAxWA;EAAoB,aAAA;EAAe,SAAA;AA6WnC;;AA5WA;EAA4B,sBAAA;EAAwB,kBAAA;AAiXpD;;AAhXA;EAAgC,eAAA;EAAiB,cAAA;EAAgB,iBAAA;AAsXjE;;AArXA;EAAwB,aAAA;EAAe,8BAAA;EAAgC,SAAA;EAAW,eAAA;EAAiB,cAAA;EAAgB,6BAAA;AA8XnH;;AA7XA;EAAiC,gBAAA;AAiYjC;;AAhYA;EAA+B,iBAAA;AAoY/B;;AAnYA;EAAqB,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,mBAAA;AA0YpF;;AAzYA;EAAuB,eAAA;EAAiB,aAAA;AA8YxC;;AA7YA;EACE;IAAqB,qCAAA;IAAuC,QAAA;EAkZ5D;EAjZA;IAAsB,qCAAA;IAAuC,SAAA;EAqZ7D;EApZA;IAA2C,aAAA;EAuZ3C;EAtZA;IAAiD,gBAAA;EAyZjD;EAxZA;IAAoB,qBAAA;IAAuB,UAAA;EA4Z3C;EA3ZA;IAAmB,4BAAA;IAA8B,2DAAA;IAA6D,iBAAA;EAga9G;EA/ZA;IAA6B,eAAA;EAka7B;EAjaA;IAAsB,aAAA;EAoatB;EAnaA;IAA0C,WAAA;EAsa1C;AACF;AApaA;EAAsB,aAAA;EAAe,QAAA;EAAU,kBAAA;EAAoB,eAAA;EAAiB,YAAA;EAAc,yBAAA;EAA2B,mBAAA;EAAqB,mBAAA;EAAqB,cAAA;AA+avK;;AA9aA;EAA6B,uBAAA;EAAyB,yBAAA;EAA2B,gBAAA;EAAkB,iBAAA;AAqbnG;;AApbA;EAAiD,gBAAA;EAAkB,qBAAA;EAAuB,cAAA;EAAgB,mDAAA;AA2b1G;;AA1bA;EAAwB,YAAA;EAAc,gBAAA;EAAkB,yBAAA;EAA2B,mBAAA;EAAqB,gBAAA;AAkcxG;;AAjcA;EAAoD,oBAAA;EAAsB,kBAAA;AAsc1E;;AArcA;EAAyB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,oBAAA;AA6cxG;;AA5cA;EAAgC,UAAA;EAAY,gBAAA;EAAkB,eAAA;AAkd9D;;AAjdA;EAA0B,0BAAA;EAA4B,cAAA;EAAgB,iBAAA;EAAmB,eAAA;EAAiB,qBAAA;EAAuB,gCAAA;EAAkC,6BAAA;AA2dnK;;AA1dA;EAAwC,0BAAA;EAA4B,oBAAA;AA+dpE;;AA9dA;EAAmB,yBAAA;EAA2B,iBAAA;EAAmB,kBAAA;EAAoB,mBAAA;EAAqB,eAAA;AAse1G;;AAreA;EAA2C,eAAA;EAAiB,WAAA;EAAa,eAAA;EAAiB,sBAAA;EAAwB,YAAA;EAAc,+BAAA;EAAiC,gCAAA;EAAkC,gBAAA;EAAkB,kBAAA;EAAoB,sBAAA;AAkfzO;;AAjfA;EAAkC,mCAAA;EAAqC,+BAAA;EAAiC,mCAAA;EAAqC,gBAAA;EAAkB,OAAA;EAAS,UAAA;EAAY,gBAAA;EAAkB,kBAAA;EAAoB,mDAAA;AA6f1N;;AA5fA;EAA6B,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAkgB9D;;AAjgBA;EAAmC,eAAA;EAAiB,uBAAA;AAsgBpD;;AArgBA;EAA4B,cAAA;EAAgB,eAAA;EAAiB,eAAA;AA2gB7D;;AA1gBA;EAA4B,gBAAA;EAAkB,MAAA;EAAQ,UAAA;EAAY,YAAA;EAAc,mBAAA;AAkhBhF;;AAjhBA;EAAwC,UAAA;AAqhBxC;;AAphBA;EAAuC,mBAAA;EAAqB,cAAA;AAyhB5D;;AAxhBA;EAAqC,gCAAA;AA4hBrC;;AA3hBA;EAA2E,mBAAA;AA+hB3E;;AA9hBA;EAAgC,mCAAA;AAkiBhC;;AAjiBA;EAA0C,aAAA;EAAe,sBAAA;EAAwB,uBAAA;EAAyB,QAAA;EAAU,WAAA;EAAa,gBAAA;EAAkB,gBAAA;EAAkB,aAAA;EAAe,6BAAA;EAA+B,SAAA;EAAW,yCAAA;EAA2C,kBAAA;EAAoB,gBAAA;EAAkB,eAAA;EAAiB,oDAAA;AAmjBhU;;AAljBA;EAAmD,UAAA;EAAY,eAAA;AAujB/D;;AAtjBA;EAAgC,yBAAA;AA0jBhC;;AAzjBA;EAA2B,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;EAAqB,eAAA;EAAiB,cAAA;AAmkB7I;;AAlkBA;EAAyB,cAAA;EAAgB,eAAA;EAAiB,kCAAA;AAwkB1D;;AAvkBA;EAA2B,cAAA;EAAgB,cAAA;EAAgB,cAAA;AA6kB3D;;AA5kBA;EAA0C,WAAA;EAAa,gBAAA;EAAkB,cAAA;EAAgB,SAAA;EAAW,kBAAA;EAAoB,uBAAA;EAAyB,eAAA;EAAiB,gBAAA;EAAkB,oDAAA;AAwlBpL;;AAvlBA;EAAgD,mBAAA;EAAqB,cAAA;AA4lBrE;;AA3lBA;EAAgC,cAAA;EAAgB,eAAA;EAAiB,cAAA;AAimBjE;;AAhmBA;EAA+B,kBAAA;AAomB/B;;AAnmBA;EACE;IAAsB,WAAA;IAAa,sBAAA;EAwmBnC;EAvmBA;IAA6B,SAAA;IAAS,mBAAA;EA2mBtC;EA1mBA;IAA0B,0BAAA;EA6mB1B;EA5mBA;IAAkC,YAAA;EA+mBlC;EA9mBA;IAAyB,uBAAA;IAAyB,oBAAA;EAknBlD;EAjnBA;IAA6B,eAAA;EAonB7B;EAnnBA;IAAgC,gBAAA;IAAkB,eAAA;EAunBlD;AACF","sourcesContent":[".schedule-planner, .schedule-dialog {\n  color: #242136;\n  button, input, select { font: inherit; }\n  button { cursor: pointer; min-height: 42px; border: 1px solid #dfe4ef; border-radius: 11px; background: #fff; color: inherit; padding: 9px 12px; font-size: 13px; font-weight: 600; }\n  button:disabled { cursor: default; opacity: .45; }\n  button:focus-visible, input:focus-visible, select:focus-visible { outline: 2px solid #ed294a; outline-offset: 2px; }\n  .schedule-primary { background: #ef2848; color: #fff; border-color: #ef2848; }\n  input:not([type=checkbox]), select { width: 100%; box-sizing: border-box; min-width: 0; min-height: 42px; border: 1px solid #dfe4ef; border-radius: 11px; background: #fff; padding: 9px 10px; color: inherit; font-size: 16px; }\n  label { display: grid; gap: 6px; font-size: 12px; color: #738099; }\n  small { display: block; font-size: 11px; font-weight: 400; line-height: 1.4; color: #738099; }\n  h2, h3, p { margin: 0; }\n  h2 { font-size: 17px; }\n  h3 { font-size: 15px; }\n  .schedule-icon { flex: none; width: 42px; padding: 0; font-size: 23px; }\n  .schedule-text-button { border: 0; padding: 4px 0; min-height: 36px; color: #ca2642; background: transparent; }\n}\n.schedule-controls { display: grid; grid-template-columns: minmax(200px, 1fr) minmax(220px, 2fr); gap: 12px; margin-bottom: 12px; }\n.schedule-month-control { display: flex; gap: 5px; min-width: 0; }\n.schedule-actions { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 12px; }\n.schedule-legend { display: flex; flex-wrap: wrap; gap: 6px 14px; margin: 10px 0 14px; font-size: 11px; color: #738099; }\n.schedule-legend span { display: flex; align-items: center; gap: 5px; }\n.schedule-legend i { width: 7px; height: 7px; border-radius: 50%; flex: none; }\n.schedule-workspace { display: grid; grid-template-columns: minmax(280px, 360px) minmax(0, 1fr); align-items: start; gap: 14px; }\n.schedule-month-card, .schedule-day-card { background: #fff; border: 1px solid #e1e6f0; border-radius: 18px; padding: 14px; min-width: 0; }\n.schedule-section-heading { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-bottom: 12px; }\n.schedule-section-heading h2 { text-transform: capitalize; }\n.schedule-section-heading > span { color: #738099; font-size: 11px; white-space: nowrap; }\n.schedule-calendar { display: grid; grid-template-columns: repeat(7, minmax(0, 1fr)); gap: 4px; }\n.schedule-calendar .schedule-weekday { text-align: center; color: #8b95aa; font-size: 11px; padding: 4px 0; }\n.schedule-calendar button { border: 1px solid transparent; padding: 4px 0; min-height: 42px; font-size: 14px; background: #f7f8fc; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 3px; }\n.schedule-calendar button.is-selected { background: #fff0f3; border-color: #ee2d4a; color: #d31e3d; }\n.schedule-calendar button.is-today > span { font-weight: 800; text-decoration: underline; text-underline-offset: 3px; }\n.schedule-dots { display: flex; justify-content: center; gap: 2px; min-height: 4px; }\n.schedule-dots b { width: 4px; height: 4px; border-radius: 50%; }\n.schedule-hint { font-size: 12px; color: #7c89a2; line-height: 1.5; }\n.schedule-month-card > .schedule-hint { margin-top: 10px; }\n.schedule-search { margin-bottom: 10px; }\n.schedule-masters { display: grid; gap: 8px; }\n.schedule-master { display: flex; align-items: center; justify-content: space-between; gap: 8px; border: 1px solid #e7eaf2; border-left: 3px solid; border-radius: 11px; padding: 10px; }\n.schedule-master > div { min-width: 0; }\n.schedule-master strong { display: block; font-size: 14px; line-height: 1.4; overflow-wrap: anywhere; }\n.schedule-master small { margin-top: 3px; }\n.schedule-master button { font-size: 11px; padding: 7px 9px; }\n.schedule-time, .schedule-off { display: block; margin-top: 6px; font-size: 13px; font-weight: 600; }\n.schedule-off { color: #9ca4b5; font-weight: 400; }\n.schedule-master.has-draft { background: #fffcf3; }\n.schedule-draft-label { color: #9e7324 !important; }\n.schedule-draft-bar { position: sticky; bottom: calc(70px + env(safe-area-inset-bottom)); z-index: 9; display: flex; align-items: center; flex-wrap: wrap; gap: 8px; background: #fff; border: 1px solid #e4e7ef; border-radius: 14px; padding: 12px; margin-top: 14px; box-shadow: 0 5px 22px #25223815; }\n.schedule-draft-bar > div { flex: 1; min-width: 120px; }\n.schedule-draft-bar strong { font-size: 14px; }\n.schedule-error, .schedule-notice { border-radius: 11px; padding: 10px 12px; margin: 10px 0 !important; font-size: 13px; line-height: 1.5; overflow-wrap: anywhere; }\n.schedule-error { color: #c22441; background: #fff1f4; }\n.schedule-error button { margin-left: 8px; }\n.schedule-notice { background: #edf7f2; color: #227855; }\n.schedule-overlay { position: fixed; inset: 0; z-index: 1200; background: #24213655; display: flex; justify-content: center; align-items: center; padding: 16px; box-sizing: border-box; }\n.schedule-dialog { width: 100%; max-width: 620px; max-height: calc(100dvh - 32px); overflow-y: auto; overscroll-behavior: contain; padding: 18px; background: #fff; border-radius: 20px; box-sizing: border-box; display: grid; gap: 14px; box-shadow: 0 10px 60px #24213630; }\n.schedule-dialog header { display: flex; align-items: center; justify-content: space-between; gap: 8px; }\n.schedule-dialog fieldset { margin: 0; padding: 10px 0 0; border: 0; border-top: 1px solid #edf0f5; min-width: 0; }\n.schedule-dialog legend { font-size: 13px; font-weight: 600; }\n.schedule-staff-options { display: grid; gap: 6px; max-height: 190px; overflow-y: auto; margin-bottom: 6px; }\n.schedule-staff-options label, .schedule-online { display: flex !important; align-items: center; gap: 8px; color: #242136; font-size: 13px; min-height: 40px; }\n.schedule-staff-options input, .schedule-online input { width: 18px; height: 18px; flex: none; accent-color: #ef2848; }\n.schedule-presets { display: flex; flex-wrap: wrap; gap: 5px; margin: 10px 0; }\n.schedule-presets button { font-size: 11px; min-height: 36px; padding: 6px 9px; background: #f5f6fa; }\n.schedule-presets button.is-selected { background: #fff0f3; border-color: #ef2848; color: #c22441; }\n.schedule-period { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 42px; gap: 8px; align-items: end; background: #f7f8fb; padding: 10px; border-radius: 12px; margin: 6px 0; }\n.schedule-period .schedule-online { grid-column: 1 / -1; min-height: 30px; }\n.schedule-preview { display: grid; gap: 12px; }\n.schedule-preview section { border-left: 3px solid; padding-left: 10px; }\n.schedule-preview section > p { font-size: 12px; color: #738099; margin: 4px 0 8px; }\n.schedule-preview-day { display: flex; justify-content: space-between; gap: 12px; font-size: 13px; padding: 8px 0; border-top: 1px solid #edf0f5; }\n.schedule-preview-day > strong { font-weight: 500; }\n.schedule-preview-day > span { text-align: right; }\n.schedule-transfer { border: 1px solid #e7eaf1; background: #f8f9fc; padding: 12px; border-radius: 12px; }\n.schedule-transfer p { font-size: 12px; margin: 8px 0; }\n@media (max-width: 760px) {\n  .schedule-controls { grid-template-columns: minmax(0, 1fr); gap: 8px; }\n  .schedule-workspace { grid-template-columns: minmax(0, 1fr); gap: 10px; }\n  .schedule-month-card, .schedule-day-card { padding: 12px; }\n  .schedule-month-card .schedule-calendar button { min-height: 40px; }\n  .schedule-overlay { align-items: flex-end; padding: 0; }\n  .schedule-dialog { border-radius: 20px 20px 0 0; padding: 14px 12px calc(18px + env(safe-area-inset-bottom)); max-height: 92dvh; }\n  .schedule-dialog header h2 { font-size: 17px; }\n  .schedule-draft-bar { padding: 10px; }\n  .schedule-draft-bar > .schedule-primary { width: 100%; }\n}\n\n.schedule-view-tabs { display: flex; gap: 4px; width: fit-content; max-width: 100%; padding: 4px; border: 1px solid #e1e6f0; border-radius: 12px; background: #edf0f6; margin: 10px 0; }\n.schedule-view-tabs button { background: transparent; border-color: transparent; min-height: 36px; padding: 7px 14px; }\n.schedule-view-tabs button[aria-selected=true] { background: #fff; border-color: #e1e6f0; color: #d52241; box-shadow: 0 2px 5px #24213608; }\n.schedule-matrix-card { min-width: 0; overflow: hidden; border: 1px solid #e1e6f0; border-radius: 16px; background: #fff; }\n.schedule-matrix-card > .schedule-section-heading { padding: 14px 14px 0; margin-bottom: 8px; }\n.schedule-matrix-tools { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 0 14px 12px; }\n.schedule-matrix-tools button { flex: none; min-height: 36px; font-size: 12px; }\n.schedule-matrix-scroll { --matrix-name-width: 164px; overflow: auto; max-height: 65dvh; max-width: 100%; scrollbar-width: thin; scrollbar-color: #bcc4d5 #f0f2f7; border-top: 1px solid #e1e6f0; }\n.schedule-matrix-scroll:focus-visible { outline: 2px solid #ed294a; outline-offset: -2px; }\n.schedule-matrix { border-collapse: separate; border-spacing: 0; width: max-content; table-layout: fixed; font-size: 12px; }\n.schedule-matrix th, .schedule-matrix td { min-width: 88px; width: 88px; max-width: 88px; box-sizing: border-box; padding: 3px; border-right: 1px solid #e3e7f0; border-bottom: 1px solid #e3e7f0; background: #fff; text-align: center; vertical-align: middle; }\n.schedule-matrix th:first-child { min-width: var(--matrix-name-width); width: var(--matrix-name-width); max-width: var(--matrix-name-width); position: sticky; left: 0; z-index: 2; text-align: left; padding: 10px 12px; box-shadow: 2px 0 3px #24213608; }\n.schedule-matrix th strong { display: block; font-size: 12px; font-weight: 600; }\n.schedule-matrix tbody th strong { font-size: 13px; overflow-wrap: anywhere; }\n.schedule-matrix th small { display: block; font-size: 10px; margin-top: 4px; }\n.schedule-matrix thead th { position: sticky; top: 0; z-index: 3; height: 52px; background: #f7f8fc; }\n.schedule-matrix thead th:first-child { z-index: 4; }\n.schedule-matrix thead th.is-weekend { background: #fff5f6; color: #d52241; }\n.schedule-matrix thead th.is-today { box-shadow: inset 0 -2px #ed294a; }\n.schedule-matrix td.is-selected-day, .schedule-matrix th.is-selected-day { background: #f6f7fc; }\n.schedule-matrix td.has-draft { box-shadow: inset 0 0 0 1px #d5a43c; }\n.schedule-matrix .schedule-matrix-shift { display: flex; flex-direction: column; justify-content: center; gap: 3px; width: 100%; padding: 6px 4px; min-height: 46px; margin: 2px 0; background: var(--salon-tint); border: 0; border-left: 3px solid var(--salon-color); border-radius: 4px; font-weight: 500; font-size: 11px; scroll-margin-inline-start: var(--matrix-name-width); }\n.schedule-matrix .schedule-matrix-shift:disabled { opacity: 1; cursor: default; }\n.schedule-matrix-shift.is-off { border-left-style: dashed; }\n.schedule-matrix-address { display: block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 10px; color: #556078; }\n.schedule-matrix-times { display: block; font-size: 10px; font-variant-numeric: tabular-nums; }\n.schedule-matrix-pending { display: block; color: #91691c; font-size: 9px; }\n.schedule-matrix .schedule-matrix-empty { width: 100%; min-height: 50px; color: #b3bbcc; border: 0; border-radius: 4px; background: transparent; font-size: 17px; font-weight: 400; scroll-margin-inline-start: var(--matrix-name-width); }\n.schedule-matrix .schedule-matrix-empty:hover { background: #fff0f3; color: #d52241; }\n.schedule-matrix-empty-static { display: block; padding: 17px 0; color: #b3bbcc; }\n.schedule-matrix-scroll-hint { padding: 10px 14px; }\n@media (max-width: 760px) {\n  .schedule-view-tabs { width: 100%; box-sizing: border-box; }\n  .schedule-view-tabs button { flex: 1; padding-inline: 8px; }\n  .schedule-matrix-scroll { --matrix-name-width: 120px; }\n  .schedule-matrix th:first-child { padding: 8px; }\n  .schedule-matrix-tools { align-items: flex-start; padding-inline: 12px; }\n  .schedule-matrix-tools > p { font-size: 11px; }\n  .schedule-matrix-tools button { padding: 6px 8px; font-size: 11px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
